export const CALENDAR_SYNC_LOOKAHEAD_DAYS = 7;

// Mirrors CALENDAR_SYNC_FRESHNESS_SECONDS in piloteer-label-api: within this
// window a manual sync is served from cache or blocked by the sync lock.
export const CALENDAR_SYNC_COOLDOWN_MS = 5 * 60 * 1000;
